/* unplugin-vue-components disabled */import { render } from "./Home.vue?vue&type=template&id=4b439b04&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=4b439b04&scoped=true&lang=css"

import exportComponent from "D:\\Song\\Demo\\hxswmj\\hxswmj_vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b439b04"]])

export default __exports__